import normalizeMappingName from './normalizeMappingName';

export const PARENT_RECORD_ID_HEADER = 'Toriut Parent Record ID';

const PARENT_RECORD_ID_NAME = normalizeMappingName(PARENT_RECORD_ID_HEADER);

export function isParentRecordIdColumn(columnName) {
  return normalizeMappingName(columnName) === PARENT_RECORD_ID_NAME;
}

export function detectParentRecordIdColumn(fileColumns) {
  if (!Array.isArray(fileColumns) || !fileColumns.length) {
    return null;
  }

  const match = fileColumns.find((columnName) => isParentRecordIdColumn(columnName));
  return match ?? null;
}
